try {
    window.$ = window.jQuery = require('jquery');
    window.SimpleMDE = require('simplemde')

    require('bootstrap5');
} catch (e) {
}

// region Material Switch
$(document).on('click', '.material-switch', function (event) {
    event.preventDefault();

    if ($(this).attr('aria-checked') === 'true') {
        $(this).attr('aria-checked', 'false');
        $(this).find('input').removeAttr('checked');
    } else {
        $(this).find('input').attr('checked', 'checked');
        $(this).attr('aria-checked', 'true');
    }
    $(this).find('input').trigger('change');
});

$(document).on('keydown', '.material-switch', function (event) {
    if (event.keyCode === 32) {
        event.preventDefault();

        if ($(this).attr('aria-checked') === 'true') {
            $(this).attr('aria-checked', 'false');
            $(this).find('input').removeAttr('checked');
        } else {
            $(this).find('input').attr('checked', 'checked');
            $(this).attr('aria-checked', 'true');
        }
        $(this).find('input').trigger('change');
        return false;
    }
    $(this).find('input').trigger('change');
});
// endregion

// region Claim select auto scroll
$('.claim-gift-section label[dusk^=gift]').on('click', function (event) {
    const firstPanel = document.querySelector('.card-default');
    if (firstPanel) {
        firstPanel.scrollIntoView({
            behavior: 'smooth'
        });
    }
})
// endregion
